import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { QuestionCompact } from '@ratehub/base-ui';

import { MORTGAGE_TERMS } from '../definitions/mortgageTerms';


function QuestionRateTerm({ name, value, ...otherProps }) {
    return (
        <QuestionCompact
            field={{
                name: name,
                type: 'choice',
                value: value,
                options: MORTGAGE_TERMS,
            }}
            renderOptionLabel={term => (
                <FormattedMessage 
                    id="mtg-common.QuestionRateTerm.yearLabel"
                    defaultMessage="{term}-year"
                    values={{
                        term: term / 12,
                    }}  
                />
            )}
            labelMessage={(
                <FormattedMessage
                    id="web-components.mortgageRateTableV2+Filter.termLabel"
                    defaultMessage="Rate term"
                />
            )}
            type="dropdown"
            {...otherProps}
        />
    );
}

QuestionRateTerm.propTypes = {
    name: PropTypes.string,
    value: PropTypes.oneOf(MORTGAGE_TERMS),
};

QuestionRateTerm.defaultProps = {
    name: 'term',
    value: undefined,
};

export default QuestionRateTerm;